import React from "react";
import contextProvider from "../../contextProvider";

import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";

import { Collapse } from "reactstrap";

const context_exposed_methods = ["toggle", "isOpened", "close", "open"];

class ReactOCollapse extends _ReactOBaseComponent {
  constructor(props) {
    //		console.log("DEBUG :: ReactOCollapse -> constructor");
    var initState = {
      opened: false,
    };
    super(props, initState);

    this.toggle = this.toggle.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.isOpened = this.isOpened.bind(this);

    if (this.props.onControllerReady) {
      this.props.onControllerReady(this.getContext().ReactOCollapse);
    }
  }

  toggle() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  close() {
    this.setState({
      opened: false,
    });
  }

  open() {
    this.setState({
      opened: true,
    });
  }

  isOpened() {
    return this.state.opened;
  }

  //
  //	Lifecycle methods
  //

  onGetChildContext() {
    return this.state;
  }

  onComponentDidMount() {
    //		console.log("DEBUG :: ReactOCollapse -> onComponentDidMount");
    if (this.props.initOpen) {
      this.getContext().ReactOCollapse.toggle();
    }
  }

  onComponentWillUnmount() {
    //		console.log("DEBUG :: ReactOCollapse -> onComponentWillUnmount");
  }

  onRender(base_component_props) {
    return (
      <Collapse
        {...base_component_props}
        style={this.props.style || {}}
        className={"reacto-collapse " + (this.props.className || "")}
        isOpen={this.state.opened}
        onEntering={this.props.onOpened ? this.props.onOpened : undefined}
        onExiting={this.props.onOpened ? this.props.onClosed : undefined}
      >
        {this.props.children}
      </Collapse>
    );
  }
}

export default contextProvider(
  withDefinedContext(ReactOCollapse, "ReactOCollapse", context_exposed_methods),
  {
    retrieve: [],
  }
);
